export const databaseAccordionField = [
  {
    id: 1,
    title: "Contact Information",
    content: [],
  },
  {
    id: 2,
    title: "Address Information",
    content: [],
  },
  {
    id: 3,
    title: "Demographic Information",
    content: [],
  },
  {
    id: 4,
    title: "Canvassing Information",
    content: [],
  },
  {
    id: 5,
    title: "Marketing Information",
    content: [],
  },
  {
    id: 6,
    title: "EITC Campaign Information",
    content: [],
  },
];
